import { Routes, RouterModule } from "@angular/router";
import { LoginPageComponent } from "./login-page/login-page.component";
import { AuthGuard } from "./auth.guard";
import { PageNotFoundComponent } from "./PageNotFound/PageNotFound.component";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { login_formComponent } from "./gotx/pages/login_form/login_form.component";
import { PasswordGenComponent } from "./gotx/pages/PasswordGen/PasswordGen.component";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RAFormModule } from "./ra-form/ra-form.module";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from "./http-loader-factory";
import { PopupModule } from "./popup/popup.module";
import { ToastrModule } from "ngx-toastr";
import { KeycloakAngularModule } from "keycloak-angular";
// import { HomeModule } from "./home/home.module";
import { change_passwordModule } from "./gotx/pages/change_password/change_password.module";
import { Data } from "./DataService";
import { RoutingService } from "./routing-service";
import { AuthService } from "./auth.service";
import { ThemeServices } from "./ThemeServices";
import { SocketioService } from "./socketio.service";
import { MarketWatchService } from "./market-watch.service";
import { NotificationService } from "./notification.service";
import { RefreshSidebarService } from "./refreshSidebar.service";
import { DecimalPipe } from "@angular/common";
import { TxTimePipe } from "./gotx/components/TxTime/tx-time.pipe";
import { HttpResponseInceptor } from "./http.interceptor";
import { MarketWatchHeader } from "./gotx/components/gotx-market-watch/MarketWatchHeader.model";
import { WatchListModel } from "./gotx/pages/WatchList/WatchList.model";
import { PopupModalComponent } from "./popup-modal/popup-modal.component";
import { gotxModalComponent } from "./gotxModal/gotxModal.component";
import { LandingComponent } from "./landing/landing.component";
import { GotxMarketWatchComponent } from "./gotx/components/gotx-market-watch/gotx-market-watch.component";
import { MainHeaderComponent } from "./main-header/main-header.component";
import { TouchlineHighlightDirective } from "./gotx/directives/touchline-highlight.directive";
import { SortDirective } from "./gotx/directives/sort.directive";
import { orderBookComponent } from "./gotx/pages/orderBook/orderBook.component";
import { tradebookComponent } from "./gotx/pages/tradebook/tradebook.component";
import { OrderEntry_NewComponent } from "./gotx/pages/OrderEntry_New/OrderEntry_New.component";
import { MarketDepthComponent } from "./gotx/pages/MarketDepth/MarketDepth.component";
import { MarketMatrixComponent } from "./gotx/components/MarketMatrix/MarketMatrix.component";
import { MarketDepthMatrixComponent } from "./gotx/pages/MarketDepthMatrix/MarketDepthMatrix.component";
import { SectorWatchComponent } from "./gotx/pages/SectorWatch/SectorWatch.component";
import { MarketStatisticsComponent } from "./gotx/pages/MarketStatistics/MarketStatistics.component";
import { buyingPowerSummaryComponent } from "./gotx/pages/buyingPowerSummary/buyingPowerSummary.component";
import { equityMarginDetailComponent } from "./gotx/pages/buyingPowerSummary/equityMarginDetail/equityMarginDetail.component";
import { equityDerMarginDetailComponent } from "./gotx/pages/buyingPowerSummary/equityDerMarginDetail/equityDerMarginDetail.component";

import { TradePositionsComponent } from "./gotx/pages/TradePositions/TradePositions.component";
import { WatchListComponent } from "./gotx/pages/WatchList/WatchList.component";
import { notificationAlertComponent } from "./gotx/pages/NotificationAlert/notificationAlert.component";
import { AnnouncementComponent } from "./gotx/pages/Announcement/Announcement.component";
import { ChartComponent } from "./gotx/pages/Chart/Chart.component";
import { pnlCalculatorComponent } from "./gotx/pages/pnlCalculator/pnlCalculator.component";
import { AuthPopupComponent } from "./gotx/pages/AuthPopup/AuthPopup.component";
import { UserPreferenceComponent } from "./gotx/pages/UserPreference/UserPreference.component";
import { marketNewsComponent } from "./gotx/pages/marketNews/marketNews.component";
import { BoardModule } from "./gotx/components/Board/Board.module";
import { ExpiryDateModule } from "./gotx/components/ExpiryDate/ExpiryDate.module";
import { ExchangeModule } from "./gotx/components/Exchange/Exchange.module";
import { ProductModule } from "./gotx/components/Product/Product.module";
import { MarginModule } from "./gotx/components/Margin/Margin.module";
import { InvestoridModule } from "./gotx/components/Investorid/Investorid.module";
import { OrderValueModule } from "./gotx/components/OrderValue/OrderValue.module";
import { PriceModule } from "./gotx/components/Price/Price.module";
import { ValdtityDateModule } from "./gotx/components/ValdtityDate/ValdtityDate.module";
import { FillTypeModule } from "./gotx/components/FillType/FillType.module";
import { RepinQtyModule } from "./gotx/components/RepinQty/RepinQty.module";
import { GotxComponentsModule } from "./gotx/components/gotx-components.module";
// import { UnitCostComponent } from "./gotx/pages/UnitCost/UnitCost.component";
import { stockStatementsComponent } from "./gotx/pages/stockStatements/stockStatements.component";

import { mtasComponent } from "./gotx/pages/mtas/mtas.component";
import { IndicatorComponent } from "./gotx/components/Indicator/Indicator.component";
import { ChartsComponent } from "./gotx/components/Chart/Chart.component";
import { MarketWatchPreferenceInfo, UserPreference, IndexList, WatchStock } from "./user-preference.model";
import { UserPreferenceService } from "./user-preference.service";
import { optionchainComponent } from "./gotx/pages/optionchain/optionchain.component";

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: 'home',
    // loadChildren: './home/home.module#HomeModule',
    component: LandingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
]

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginPageComponent,
    login_formComponent,
    PasswordGenComponent,    
    LandingComponent,
    GotxMarketWatchComponent,
    MainHeaderComponent,
    TouchlineHighlightDirective,
    SortDirective,
    orderBookComponent,
    tradebookComponent,
    OrderEntry_NewComponent,
    MarketDepthComponent,
    MarketMatrixComponent,
    MarketDepthMatrixComponent,
    SectorWatchComponent,
    MarketStatisticsComponent,
    buyingPowerSummaryComponent,
    equityMarginDetailComponent,
    TradePositionsComponent,
    stockStatementsComponent,
    WatchListComponent,
    notificationAlertComponent,
    AnnouncementComponent,
    optionchainComponent,
    ChartComponent,
    ChartsComponent,
    pnlCalculatorComponent,
    AuthPopupComponent,
    UserPreferenceComponent,
    marketNewsComponent,
    gotxModalComponent,
    mtasComponent,
    IndicatorComponent,  
    equityDerMarginDetailComponent, 
    // UnitCostComponent
    ],
  exports: [
    RouterModule
  ],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    RAFormModule,
    NgbModalModule,
    Ng4LoadingSpinnerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    PopupModule,
    ToastrModule.forRoot(),
    KeycloakAngularModule, 
    // HomeModule,
    change_passwordModule,    
    // HomeRoutingModule,
    BoardModule,
    ExpiryDateModule,
    ExchangeModule,
    ProductModule,
    MarginModule,
    InvestoridModule,
    OrderValueModule,
    PriceModule,
    ValdtityDateModule,
    FillTypeModule,
    RepinQtyModule,
    GotxComponentsModule,
    // mtasChartModule
  ],
  providers: [
    Data,
    RoutingService,
    AuthService,
    AuthGuard,
    ThemeServices,
    SocketioService,
    MarketWatchService,
    NotificationService,
    RefreshSidebarService,
    DecimalPipe,
    TxTimePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInceptor, multi: true },
    // { provide: APP_INITIALIZER,useFactory: initializer,multi: true,deps: [KeycloakService,KeyconfigInitService]},
    MarketWatchHeader,
    WatchListModel,
    UserPreferenceService, UserPreference, MarketWatchPreferenceInfo, IndexList, WatchStock,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    PopupModalComponent,
    gotxModalComponent,
    // UnitCostComponent
    // mtasChartComponent   
  ],
})
export class AppModule {
}


export { HttpLoaderFactory };
// export function HttpLoaderFactory(http: HttpClient) { // Moved to Seperate File By Mirsha
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }